module.exports = __webpack_public_path__ + "static/media/krieg-der-bilder.fe6aa62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/krieg-der-bilder.png
// module id = 204
// module chunks = 0